import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { useSnackbar } from 'notistack';

import * as api from '../../../../services/api/admin';

const ImportPatients = ({ classes }) => {
  const [csvFile, setCsvFile] = useState({});
  const { enqueueSnackbar } = useSnackbar();

  const onFileUpload = async () => {
    try {
      const data = new FormData();
      data.append('file', csvFile);
      data.append('name', csvFile.name);
      const response = await api.importPatients(data);
      enqueueSnackbar(response.data.message, { variant: response.data.status });
    } catch (err) {
      console.error(err);
      enqueueSnackbar("Couldn't upload patients", { variant: 'error' });
    }
  };

  return (
    <Grid container spacing={16}>
      <Grid item xs={12}>
        <input
          accept=".csv"
          style={{ display: 'none' }}
          id="raised-button-file"
          multiple
          type="file"
          onChange={el => setCsvFile(el.target.files[0])}
        />

        <label htmlFor="raised-button-file">
          <Button variant="contained" component="span">
            Choose file
          </Button>
        </label>
      </Grid>

      <Grid item xs={12}>
        {csvFile.name ? csvFile.name : 'No selected files'}
      </Grid>

      <Grid item xs={4}>
        <Button
          fullWidth
          color="primary"
          variant="contained"
          onClick={onFileUpload}
        >
          + Import patients
        </Button>
      </Grid>

      <Grid item xs={12}>
        <Typography variant="h4">Notes</Typography>

        <Typography variant="body1">
          You can upload patients via CSV. The CSV must follow a standard format
          but anyone on the tech team can help you translate a patient dump into
          the required format.
        </Typography>

        <Typography variant="body1">
          The following user properties are required:
        </Typography>

        <ul className={classes.list}>
          <li>Patient First Name</li>
          <li>Patient Last Name</li>
          <li>Patient Email</li>
          <li>Patient Phone Number</li>
          <li>Patient Gender (Must be "male" or "female" - case sensitive)</li>
          <li>Patient Birthdate (Almost all date formats are supported)</li>
          <li>Practice ID</li>
        </ul>

        <Typography variant="body1">
          Note: "Practice ID" you can find in Google Data Studio under the
          "Practices" tab.
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography variant="body1">
          You can download one of sample csv files below. All uploaded files
          must follow one of the formats below.
        </Typography>

        <ul className={classes.list}>
          <li>
            <a href="/patient-upload-example-1.csv" download>
              Example 1
            </a>
          </li>
          <li>
            <a href="/patient-upload-example-2.csv" download>
              Example 2 (with full name)
            </a>
          </li>
        </ul>
      </Grid>
    </Grid>
  );
};

const styles = () => ({
  list: {
    paddingLeft: '2em',
    paddingBottom: '2em',
  },
});

export default withStyles(styles)(ImportPatients);
